/* global axios */
import ApiClient from '../ApiClient';

class KanbanBoardStepsAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  stepsUrl(boardId) {
    return `${this.url}/${boardId}/board_steps`;
  }

  create(boardId, step) {
    return axios.post(this.stepsUrl(boardId), { board_step: step });
  }

  update(boardId, stepId, step) {
    return axios.patch(`${this.stepsUrl(boardId)}/${stepId}`, {
      board_step: step,
    });
  }

  destroy(boardId, stepId) {
    return axios.delete(`${this.stepsUrl(boardId)}/${stepId}`);
  }
}

export default new KanbanBoardStepsAPI();
